import { defineComponent as _defineComponent } from 'vue'
export interface Props<T = any> {
  options: T[];
  selection: T[];
  optionsLabel?: string;
  selectionLabel?: string;
  text: (item: T) => string;
  subtext: (item: T) => string;
}

export type Emits<T = unknown> = (
  event: 'selection-updated',
  value: T[],
) => void;


import { ref, computed, watch, watchEffect } from 'vue';
import find from 'lodash/find';

import { faArrowLeft } from '@icons/regular/faArrowLeft';
import { faArrowRight } from '@icons/regular/faArrowRight';

import SelectionGroup from './SelectionGroup.vue';

declare module 'vue/types/vue' {
  export interface Vue {
    SelectionPanel: ComponentWithProps<Props>;
  }
}

export interface ListItem<T = unknown> {
  id: number;
  item: T;
}

const __default__ = { name: 'SelectionPanel' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    options: null,
    selection: null,
    optionsLabel: null,
    selectionLabel: null,
    text: null,
    subtext: null
  },
  emits: ["selection-updated"],
  setup(__props: any, { emit }: { emit: ((
  event: 'selection-updated',
  value: T[],
) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: T[];
  selection: T[];
  optionsLabel?: string;
  selectionLabel?: string;
  text: (item: T) => string;
  subtext: (item: T) => string;
};

/**
 * `SelectionPanel` component properties.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any




// const items = ref< ListItem<T>[]>
const listItems = ref<ListItem[]>([]);
const selectionIds = ref<number[]>([]);

watch(selectionIds, (ids) => {
  const value: unknown[] = [];

  for (const id of ids) {
    const item = find(listItems.value, { id })?.item;

    if (!item) {
      throw new Error(
        '[SelectionPanel:onSelectionChanged] could not find an internally tacked item by its ID.',
      );
    }

    value.push(item);
  }

  emit('selection-updated', value);
});

const groups = computed(() => {
  const left: ListItem[] = [];
  const right: ListItem[] = [];

  for (const item of listItems.value) {
    const group = selectionIds.value.includes(item.id) ? right : left;

    group.push(item);
  }

  return { left, right };
});

function add(id: number) {
  selectionIds.value = [...selectionIds.value, id];
}

function remove(id: number) {
  selectionIds.value = selectionIds.value.filter((_id) => _id !== id);
}

function addAll() {
  selectionIds.value = listItems.value.map(({ id }) => id);
}

function removeAll() {
  selectionIds.value = [];
}

// /**
//  * ...
//  *
//  * @returns
//  */
// function generateLists() {
//   const items: ListItem[] = [];
//   const ids: number[] = [];

//   let count = 0;

//   for (const item of props.options) {
//     items.push({ id: count++, item });
//   }

//   for (const item of props.selection) {
//     const id = count++;

//     items.push({ id, item });
//     ids.push(id);
//   }

//   listItems.value = items;
//   selectionIds.value = ids;
// }

watchEffect(() => {
  const items: ListItem[] = [];
  const ids: number[] = [];

  let count = 0;

  for (const item of props.options) {
    items.push({ id: count++, item });
  }

  for (const item of props.selection) {
    const id = count++;

    items.push({ id, item });
    ids.push(id);
  }

  listItems.value = items;
  selectionIds.value = ids;
});

return { __sfc: true,props, emit, listItems, selectionIds, groups, add, remove, addAll, removeAll, faArrowLeft, faArrowRight, SelectionGroup }
}

})